const sitemapOpenClass = 'is-open';

const sitemapInit = () => {
    const $component = $('.component-sitemap ul');
    const $sitemapIcon = $('.component-sitemap-icon-source svg');

    if($component.length === 0) return;

    $component.find('li ul')
        .closest('li')
        .prepend($sitemapIcon.clone())
        .find('ul').slideUp();

    $('.sitemap-icon-trigger').on('click', function() {
        const $el = $(this);
        const $li = $el.closest('li');

        toggleSitemapItem($li);

    });
};

const toggleSitemapItem = $sitemapItem => {
    if($sitemapItem.hasClass(sitemapOpenClass)) {
        $sitemapItem.removeClass(sitemapOpenClass).find('> ul').slideUp();
    } else {
        $sitemapItem.addClass(sitemapOpenClass).find('> ul').slideDown();
    }
};

sitemapInit();



/** WEBPACK FOOTER **
 ** ./src/components/sitemap/index.js
 **/